'use client';

import Link from 'next/link';

import { cn } from '@/lib/utils';

export interface BrandWordmarkProps {
  /** If set, wraps the wordmark in a dashboard link */
  href?: string | null;
  className?: string;
  /**
   * `true`: text follows `--topnav-foreground` — use on app chrome ( **`prototype`** top bar).
   */
  chromed?: boolean;
}

/** Typography mirrors **`prototype/VunaPay_Prototype.html`** `.topnav-logo` / style guide `.topbar-logo`. */
export function BrandWordmark({ href = null, className, chromed = false }: BrandWordmarkProps) {
  const baseText = chromed ? 'text-[color:var(--topnav-foreground)]' : 'text-[#0B1F3A]';

  const mark = (
    <span
      className={cn(
        'font-display text-[1.3rem] font-bold leading-none tracking-tight sm:text-[1.35rem]',
        baseText,
        className,
      )}
    >
      Vuna<span className="text-brand-gold">Pay</span>
    </span>
  );

  if (href) {
    return (
      <Link
        href={href}
        className={cn(
          'inline-flex items-center rounded-md outline-none ring-offset-background focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2',
          chromed && 'focus-visible:ring-offset-[color:var(--topnav-background)]',
        )}
      >
        {mark}
      </Link>
    );
  }

  return mark;
}
